import { createContext } from 'react';

const PackageServicesContext = createContext<any>({
  items: null
});

export default PackageServicesContext;
